import "vuetify/styles";
import "@/styles/global.scss";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

const light = {
  dark: false,
  colors: {
    background: "#fafafa",
    correctionBlue: "#1564bd",
    primaryGreen: "#3ACAC9",
    primaryGreenLighter: "#DBF4F3",
    alertRed: "#D72E4B",
    alertRedBackground: "#FFEEF1",
  },
};

const dark = {
  dark: true,
  colors: {},
};

const vuetify = createVuetify({
  theme: {
    defaultTheme: "light",
    themes: {
      light,
      dark,
    },
  },
  // icons: {
  //   defaultSet: "mdi",
  // },
  options: {
    customProperties: true
  },
  components,
  directives,
});

export default vuetify;
